import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

import { LegendComponent, componentMap } from '.'

export type LegendProps = {
  components: LegendComponent[]
}

type Emit = {
  (e: 'change', label: string, checked: boolean): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LegendBase',
  props: {
    components: {}
  },
  emits: ["change"],
  setup(__props: any) {




function removeType<T, O extends { type: T }>(x: O): Omit<O, 'type'> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { type, ...rest } = x
  return rest
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component, i) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentMap)[component.type]), _mergeProps({ key: i }, { ref_for: true }, removeType(component), {
      onChange: ($event: any) => (_ctx.$emit('change', component.label, $event))
    }), null, 16, ["onChange"]))
  }), 128))
}
}

})